import Modal from './modal';
var Modals = /** @class */ (function () {
    function Modals() {
        this.modals = {};
        this.number = 0;
        this.defaults = {
            modal: Modal
        };
        this.initGlobalEvents();
    }
    Modals.prototype.register = function (modal, key) {
        if (key === void 0) { key = ''; }
        if (!key) {
            key = 'm' + this.number;
        }
        this.modals[key] = modal;
        this.number++;
        return modal;
    };
    Modals.prototype.get = function (key) {
        return this.modals.hasOwnProperty(key) ? this.modals[key] : null;
    };
    Modals.prototype.open = function (key) {
        if (this.get(key)) {
            this.get(key).open();
        }
    };
    Modals.prototype.close = function (key) {
        if (this.get(key)) {
            this.get(key).close();
        }
    };
    Modals.prototype.closeAll = function () {
        for (var key in this.modals) {
            this.close(key);
        }
    };
    Modals.prototype.initGlobalEvents = function () {
        var _this = this;
        document.addEventListener('click', function (e) {
            var target = e.target;
            if (target.dataset.acModal) {
                e.preventDefault();
                _this.open(target.dataset.acModal);
            }
        });
    };
    return Modals;
}());
export default Modals;
